export const invoiceActionTypes = {
  SET_INVOICE: 'SET_INVOICE',
  SET_INVOICE_SERVICES: 'SET_INVOICE_SERVICES',
  SET_INVOICE_SERVICES_ERROR: 'SET_INVOICE_SERVICES_ERROR',
  ADD_ACTIVE_SERVICE: 'ADD_ACTIVE_SERVICE',
  REMOVE_ACTIVE_SERVICE: 'REMOVE_ACTIVE_SERVICE',
  UPDATE_INVOICE_ROW_VERSION: 'UPDATE_ROW_VERSION',
  UPDATE_INVOICE_ERROR: 'UPDATE_INVOICE_ERROR',
  UPDATE_INVOICE_SUCCESS: 'UPDATE_INVOICE_SUCCESS',
  SAVE_NEW_INVOICE_SUCCESS: 'SAVE_NEW_INVOICE_SUCCESS',
  SAVE_NEW_INVOICE_ERROR: 'SAVE_NEW_INVOICE_ERROR',
  CHANGE_SERVICE_PRICE: 'CHANGE_SERVICE_PRICE',
  RESET_INVOICE: 'RESET_INVOICE'
};
